var map = {
	"./rank_1.png": "8442",
	"./rank_2.png": "9579",
	"./rank_3.png": "43fc",
	"./rank_4.png": "e37f",
	"./rank_5.png": "b4a3",
	"./rank_empty.png": "fbf5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c18";